<template>
<el-card>
    <template v-slot:header>
        <div class="clearfix">
            <span style="font-weight: bold;">
                <i class="icon iconfont icon-fsux_tubiao_weientu" style="font-weight: bold;margin-right: 5px;font-size: 20px;"></i>
                {{chartTitle}}
            </span>
        </div>
    </template>
    <div>
        <div ref="venn" style="width: 100%; height: 500px;"></div>
    </div>
</el-card>
</template>

<script>
import Highcharts from 'highcharts';
import highchartsVenn from 'highcharts/modules/venn';
import exporting from "highcharts/modules/exporting";

// 引入 Highcharts Venn 模块
highchartsVenn(Highcharts);
// 引入导出模块
exporting(Highcharts);

export default {
    props: {
        overlapRegions: Array,
        nonOverlapRegions1: Array,
        nonOverlapRegions2: Array,
        chartTitle: {
            type: String,
            default: 'Overlap Analysis Result',
        },
    },
    data() {
        return {
            chart: null,
            chartData: null,
            chartOptions: null,
        };
    },
    mounted() {
        this.initChart();
         // 引入导出模块
        require('highcharts/modules/exporting')(Highcharts);
    },
    watch: {
        // 监听 props 属性的变化，并重新生成 Venn 图表
        overlapRegions: function () {
            this.updateChart();
        },
        nonOverlapRegions1: function () {
            this.updateChart();
        },
        nonOverlapRegions2: function () {
            this.updateChart();
        },
    },
    methods: {
        initChart() {
            const overlapRegionsCount = this.overlapRegions.length;
            const nonOverlapRegions1Count = this.nonOverlapRegions1.length;
            const nonOverlapRegions2Count = this.nonOverlapRegions2.length;
            // 生成 Venn 图表数据
            this.chartData = [
                { sets: ['Bed1_regions'], value: overlapRegionsCount + nonOverlapRegions1Count, name: `Bed1_regions`, },
                { sets: ['Bed2_regions'], value: overlapRegionsCount + nonOverlapRegions2Count, name: `Bed2_regions`, },
                { sets: ['Bed1_regions', 'Bed2_regions'], value: overlapRegionsCount, name: `overlap_regions`, },
            ];
            // 配置 Venn 图表选项
            this.chartOptions = {
                chart: {
                    type: 'venn',
                    spacing: [0, 0, 0, 0]
                },
                title: {
                    text: this.chartTitle,
                },
                series: [{
                    data: this.chartData,
                    size: '80%',
                    colorByPoint: true, // 设置 colorByPoint 为 true
                    colors: ['#7cb5ec', '#f7a35c', '#90ee7e'], // 配置数据点颜色（可选）
                    dataLabels: {
                        enabled: true, // 开启数据点标签
                        format: '{point.name}:{point.value}', // 配置标签格式
                        style: {
                            fontSize: '15px', // 配置标签样式
                            fontWeight: 'bold',
                            textOutline: false,
                        },
                        align: 'center', // 配置标签位置
                        verticalAlign: 'middle',
                    },
                }],
                accessibility: {
                enabled: false,
                },
                exporting: {
                    enabled: true,
                    buttons: {
                        contextButton: {
                            menuItems: ['downloadPNG', 'downloadPDF', 'downloadSVG'], // 添加导出选项
                            symbolSize: 20, // 设置导出按钮图标的大小
                            theme: {
                                fill: '#599BDF', // 修改按钮颜色
                            },
                        }
                    }
                },
                credits: { } // 禁用 Highcharts 默认的版权信息
            };
            // 初始化 Highcharts 实例并绘制 Venn 图表
            this.chart = Highcharts.chart(this.$refs.venn,this.chartOptions);
        },
        updateChart() {
            const overlapRegionsCount = this.overlapRegions.length;
            const nonOverlapRegions1Count = this.nonOverlapRegions1.length;
            const nonOverlapRegions2Count = this.nonOverlapRegions2.length;
            // 更新 Venn 图表数据
            this.chartData = [
                { sets: ['Bed1_regions'], value: overlapRegionsCount + nonOverlapRegions1Count },
                { sets: ['Bed2_regions'], value: overlapRegionsCount + nonOverlapRegions2Count },
                { sets: ['Bed1_regions', 'Bed2_regions'], value: overlapRegionsCount, name: 'overlap_regions' },
            ];
            // 更新 Highcharts 实例中的 Venn 图表
            this.chart.series[0].setData(this.chartData);
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/overlap/Overlapfig2.vue